import { useQueries } from "@tanstack/react-query";
import { axiosInstance } from "@abb-connect/react-shared";
import { RootEquipmentStatusResult } from "@models/root-equipment-status-result";

export function useRootEquipmentStatusApi(sites: string[]) {
  return useQueries({
    queries: sites.map((site) => ({
      queryKey: [site, "root-equipment-status"],
      queryFn: async (): Promise<RootEquipmentStatusResult[]> => {
        const url = `/sites/${site}/telemetry/root-equipment-status`;
        return (await axiosInstance.get<RootEquipmentStatusResult[]>(url)).data;
      },
      staleTime: 30_000,
      enabled: !!site,
    })),
  });
}
